module.exports = __webpack_public_path__ + "assets/2bec3603ea07834577202be276f39489.mp3";